<template>
  <div class="col-md-4  pb-3">
    <div class="card" style="z-index: 0">
      <div class="cover" :class="[page.picture && 'cover-custom-img']">
        <img v-if="page.picture" class="card-img-top"
             v-show="imageLoaded"
             @load="imageLoaded = true"
             alt=""
             :src="page.picture_thumb_module">

        <img class="card-img-top"
             v-show="!imageLoaded"
             alt=""
             src="@/assets/app/media/img/misc/placeholder.png">
      </div>
      <div class="card-body">
        <h6 class="card-title ellipsis" v-encode="page.title"></h6>
        <div class="card-text">
          <span class="m-widget24__change">
            {{ $t('Published') }}: {{ slicePageDate() }}
					</span>
          <div class="m-widget19__action mt-4 d-flex justify-content-center">
            <button type="button" class="btn m-btn--pill m-btn m-btn--custom btn-outline-light btn-ls m-btn--hover-ls" @click="redirectToPage">
              {{ $t('View') }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions} from 'vuex'
import Encode from "@/directives/encode";
import ClickOutside from 'vue-click-outside'

export default {
  name: "Page",
  props: {
    page: Object
  },
  directives: {
    Encode,
    ClickOutside,
  },
  data() {
    return {
      imageLoaded: false,
    }
  },
  methods: {
    ...mapActions([
      'setOrder',
      'setDigitalOrder',
    ]),

    redirectToPage(){
      this.$router.push({name: 'CustomPage', params: {pageUuid: this.page.uuid, back: true}});
    },

    slicePageDate(){
      return this.page.date_add.slice(0, 10);
    }
  },
  computed: {}
}
</script>

<style scoped>
.shadow {
  background-color: green;
  -webkit-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
  -moz-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
  box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-title {
  cursor: pointer;
}

.cover {
  position: relative; /* Not required now */
  float: left;
  -webkit-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
  -moz-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
  box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
}

.cover img {
  display: block;
  position: relative;
  z-index: -1;
}
</style>